<div class="close-modal" (click)="onCancel()" (keydown.escape)="onCancel()" tabindex="0">
    <mat-icon>close</mat-icon>
</div>
<h1 mat-dialog-title>Dialogtitel</h1>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="userForm" autocomplete="off" novalidate>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
            <input
              matInput
              formControlName="name"
            />
            @if (userForm.get('name')?.hasError('required')) {
              <mat-error>Name ist erforderlich</mat-error>
            }
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>URL</mat-label>
            <input
              matInput
              formControlName="url"
            />
            @if (userForm.get('url')?.hasError('required')) {
              <mat-error>URL ist erforderlich</mat-error>
            }
            @if (userForm.get('url')?.hasError('pattern')) {
              <mat-error>URL muss valide sein</mat-error>
            }
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Beschreibung</mat-label>
            <input
              matInput
              formControlName="description"
            />
            @if (userForm.get('description')?.hasError('required')) {
              <mat-error>Beschreibung ist erforderlich</mat-error>
            }
      </mat-form-field>
    </p>
    <p>
      <mat-form-field>
        <mat-label>Combobox</mat-label>
        <mat-select>
          <mat-option [value]="">---</mat-option>
          @for (comboBoxValue of comboBoxValues; track comboBoxValue) {
          <mat-option [value]="comboBoxValue">{{comboBoxValue}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p> 
</form>
</mat-dialog-content>
<mat-divider style="margin-top: 30px;"></mat-divider>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="onSave()">Speichern</button>
</div>
